import { LoadingButton } from "@mui/lab";
import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import React, { useState } from "react";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import PostHooks from "../../../Api/PostHooks";
import AlertComponent from "../../../Components/AlertComponent";

const BoostShares = ({ user, onClose, fetchUser }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const [buyLoading, buyResponse, buyRequest] = PostHooks();

  const addShares = async (e) => {
    try {
      let formData = {
        type: "buy",
        transafer_type:
          user.shares === 0 ? "first_sacco_sell" : "normal_sacco_sell",
        no_ofshares: e.no_of_shares,
        customer_entity_id: user.id,
      };

      const boost = await buyRequest({
        url: "/shares",
        body: formData,
      });

      if (boost && boost.status === 200 && boost.data.StatusCode === 0) {
        setSnackbar({
          open: true,
          severity: "success",
          message: "Share purchase successful",
        });

        setTimeout(() => {
          onClose();
          fetchUser();
        }, 2000);
      } else if (
        boost &&
        (boost.status === 200 || boost.status !== 200) &&
        boost.data.StatusCode !== 0
      ) {
        setSnackbar({
          open: true,
          severity: "error",
          message: boost.data.StatusMessage,
        });
      }
    } catch (error) {
      console.log("boost shares err", error);
      const errorMessage =
        error.response?.data?.StatusMessage ??
        error.response?.data?.message ??
        error.message ??
        "An unexpected error occurred. Please try again.";

      setSnackbar({
        open: true,
        severity: "error",
        message: errorMessage,
      });
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit(addShares)}>
        <AlertComponent
          open={snackbar.open}
          handleSnackbar={handleSnackbarClose}
          severity={{ severity: snackbar.severity, message: snackbar.message }}
        />

        <FormControl
          fullWidth
          error={!!errors.no_of_shares}
          sx={{
            mt: "5px",
          }}
        >
          <InputLabel htmlFor="no_of_shares">Number of shares</InputLabel>
          <OutlinedInput
            id="no_of_shares"
            type="number"
            {...register("no_of_shares", { required: true })}
            label="Number of shares"
            variant="filled"
            inputProps={{ step: "any", min: 0 }}
          />
          {errors.no_of_shares && <FormHelperText>Required</FormHelperText>}
        </FormControl>

        <Box
          sx={{
            pt: "40px",

            display: "flex",
            direction: "row",
            justifyContent: "flex-end",
          }}
        >
          <Button variant="text" type="reset" onClick={() => onClose()}>
            Cancel
          </Button>
          <LoadingButton
            loading={buyLoading}
            color="primary"
            variant="contained"
            type="submit"
          >
            Submit
          </LoadingButton>
        </Box>
      </form>
    </div>
  );
};

export default BoostShares;
